//import styles from './analyticsLineItem.module.css'
import { AnalyticsFrame, AnalyticsListText } from './style'

interface AnalyticsLineItemProps {
  serviceName: string
  servicePercentage: string | number
}

function AnalyticsLineItem({
  serviceName,
  servicePercentage,
}: AnalyticsLineItemProps) {
  return (
    <AnalyticsFrame key={serviceName}>
      <AnalyticsListText>{serviceName}</AnalyticsListText>
      <AnalyticsListText>{servicePercentage} %</AnalyticsListText>
    </AnalyticsFrame>
  )
}

export default AnalyticsLineItem
